import widgetDataTypes from "./widgetDataTypes";

export default {
    [widgetDataTypes.LINES_TYPE_ID]: 'TimeLineChart',
    [widgetDataTypes.BARS_WITH_LINES_TYPE_ID]: 'TimeLineChart',
    [widgetDataTypes.X_AXIS_TYPE_ID]: 'XaxisChart',
    [widgetDataTypes.TABLE_TYPE_ID]: 'TableData',
    [widgetDataTypes.COUNTER_TYPE_ID]: 'StatusCards',
    [widgetDataTypes.CHART_SPEEDOMETER]: 'GaugeChart',
    [widgetDataTypes.CHART_QUEUE]: 'QueueChart',
    [widgetDataTypes.EXTENSION_CARDS]: 'ExtensionCards',
    [widgetDataTypes.HISTORY_COUNTERS]: 'StatisticsCards',
    [widgetDataTypes.QUEUE_DASHBOARD]: 'QueueDashboard',
    [widgetDataTypes.QUEUE_COUNTER_TYPE_ID]: 'QueueCards',
    [widgetDataTypes.QUEUE_ACTIVE_CALL]: 'QueueActiveCall',
    [widgetDataTypes.EXTERNAL_DATA_TYPE_ID]: 'ExternalDataWidget',
    // [widgetDataTypes.INFO_TYPE_ID]: 'CounterCard',
    [widgetDataTypes.PIE_TYPE_ID]: 'PieChart',
    [widgetDataTypes.RICH_TEXT_EDITOR_ID]: 'HtmlWidget',
    [widgetDataTypes.TOTAL_OUTGOING_CALLS]: 'TotalOutgoingCall',
    [widgetDataTypes.CHART_AREA_ID]: 'AreaChart',
    [widgetDataTypes.RICH_TEXT_EDITOR_LIST]: 'WidgetNoteList',
    [widgetDataTypes.AVERAGE_CALLS_DURATION]: 'AverageCallDuration',
    [widgetDataTypes.FUNNEL_3D_TYPE_ID]: 'Funnel3DChart',
    [widgetDataTypes.DIALERS_TYPE_ID]: 'SocketsRealTimeTable',
    [widgetDataTypes.INFO_TYPE_ID]: 'SocketsRealTimeFunnel',
    [widgetDataTypes.EXTENSION_CARDS_STATISTICS]: 'RedesignExtensionCards'

}
